import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IMAGE_CONSTANTS } from '../../constants/ImageConstans';
import { logger } from '../../utils/logger';
import mqttService from '../../services/mqttService';
import { stashRapFireNextQuestion } from '../../utils/rapFirePendingQuestion';
import ParentContainor from '../../components/base/ParentContainor';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import Card from '../../components/base/Card';
import GradientText from '../../components/base/GradientText';
import ImageView from '../../components/base/ImageView';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { getRapFireGameList, getRapFireParticipantsList } from '../../network/network_callbacks';
import { FONTS } from '../../constants/Fonts';
import Button from '../../components/base/Button';
import QRCode from '../../components/QRCode';

const RapFireWaiting = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { nextGame } = location.state || {};

    const [isRetryModeOn, setIsRetryModeOn] = useState(false);
    const [rapFireGameList, setRapFireGameList] = useState(null);
    const [rapFireNoGameList, setRapFireNoGameList] = useState(null);
    const [rapFireGameDetail, setRapFireGameDetail] = useState(null);
    const [contestIdForMqtt, setContestIdForMqtt] = useState(null);
    const [joinedUsersList, setJoinedUsersList] = useState([]);
    const [isGameLoading, setIsGameLoading] = useState(true);
    const [initialResumeTimerMs, setInitialResumeTimerMs] = useState(60 * 1000);
    const [timerDisplay, setTimerDisplay] = useState('00 : 00');
    const [isStartEnabled, setIsStartEnabled] = useState(false);

    useEffect(() => {
        //logger.log('Rapchick RapFireWaiting');
        gameListRapFire();
        return () => {
            //disconnectMQTT();
        };
    }, [navigate]);

    // Helper to format ms as mm : ss
    function formatMs(ms) {
        const totalSeconds = Math.max(0, Math.floor(ms / 1000));
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${minutes} : ${seconds}`;
    }

    // Timer effect for initialResumeTimerMs
    useEffect(() => {
        let interval = null;
        if (isGameLoading && initialResumeTimerMs > 0) {
            let ms = initialResumeTimerMs;
            setTimerDisplay(formatMs(ms));
            interval = setInterval(() => {
                ms -= 1000;
                if (ms < 0) ms = 0;
                setTimerDisplay(formatMs(ms));
                if (ms === 0) {
                    clearInterval(interval);
                    setInitialResumeTimerMs(0);
                    setTimerDisplay("00 : 00");
                    setIsGameLoading(false);
                    setRapFireNoGameList('Sorry, Game abandoned due to insufficient players.');
                    setIsRetryModeOn(true);
                }
            }, 1000);
        } else {
            setTimerDisplay(formatMs(initialResumeTimerMs));
        }
        return () => interval && clearInterval(interval);
    }, [isGameLoading, initialResumeTimerMs]);

    const getRapFireParticipantsFromApi = async (contestId) => {
        try {
            const response = await getRapFireParticipantsList(contestId);
            const gameData = response?.data;
            const participants = gameData?.data?.contest?.participants || [];
            console.log('✅ Joined game successfully getRapFireParticipantsList response:', response?.data);
            if (gameData?.responseCode === 200 && gameData?.data?.contest?.participants) {
                return participants;
            }
            else {
                return [];
            }
        } catch (error) {
            console.error('❌ Failed to getRapFireParticipantsList:', error);
            return [];
        }
    }

    const gameListRapFire = async () => {
        try {
            //setIsGameLoading(false);
            const response = await getRapFireGameList();
            const gameData = response?.data;
            console.log('✅ Joined game successfully getRapFireGameList response:', response?.data);
            if (gameData?.responseCode === 200 && gameData?.data && gameData?.data?.contest?.contestId) {
                const contestId = gameData?.data?.contest?.contestId;
                const status = gameData?.data?.contest?.status;  //'active', 'lobby'
                const maxSpots = gameData?.data?.contest?.maxSpots;
                const minSpot = gameData?.data?.contest?.minSpots;
                const filledSpot = gameData?.data?.contest?.filledSpots;
                const lobbyTime = gameData?.data?.contest?.lobbyTime;
                const questionTime = gameData?.data?.contest?.questionTime;
                const gameType = gameData?.data?.contest?.gameType;
                const gameMode = gameData?.data?.contest?.gameMode;
                const participants = gameData?.data?.contest?.participants || [];
                const participantsList = await getRapFireParticipantsFromApi(contestId);
                if (status === 'lobby' || status === 'active') {
                    logger.log('✅ Joined game successfully getRapFireGameList1:', response?.data);
                    setIsRetryModeOn(false);
                    setIsGameLoading(true);
                    setInitialResumeTimerMs(60 * 1000);
                    setTimerDisplay(formatMs(60 * 1000));
                    setRapFireGameList(response?.data?.data?.contest);
                    if (participantsList.length > 0) {
                        setJoinedUsersList(participantsList);
                    }
                    else {
                        setJoinedUsersList(participants);
                    }
                    initMQTTClient(contestId);
                    setRapFireNoGameList(null);
                    if (filledSpot > minSpot) {
                        setIsStartEnabled(true);
                    }
                }
                else {
                    // logger.log('❌ No active game found in getRapFireGameList2:', response?.data);
                    // const error = gameData?.data?.error;
                    // setIsGameLoading(false);
                    // setInitialResumeTimerMs(0);
                    // setTimerDisplay("00 : 00");
                    // setRapFireNoGameList(null);
                    // //setJoinedUsersList([]);
                    // setRapFireGameList(null);
                    // setRapFireNoGameList(error?.message || 'No active game found.');
                }
            } else if (gameData?.responseCode === 500) {
                logger.log('❌ No active game found in getRapFireGameList3:', response?.data);
                const error = gameData?.data?.error;
                setIsGameLoading(false);
                setInitialResumeTimerMs(0);
                setTimerDisplay("00 : 00");
                setRapFireNoGameList(null);
                setJoinedUsersList([]);
                setRapFireGameList(null);
                setRapFireNoGameList(error?.message || 'No active game found.');
            }
        } catch (error) {
            console.error('❌ Failed to joinGame:', error);
        }
    }

    const initMQTTClient = async (contestId) => {
        mqttService.connect('game/room/', contestId, {
            'start_game': (payload) => {
                logger.log('MQTT start_game:', payload);
            },
            'end_game': async (payload) => {
                logger.log('MQTT end_game:', payload);
            },
            'USER_JOINED': async (payload) => {
                console.log('MQTT USER_JOINED raw payload:', payload);
                logger.log('MQTT USER_JOINED:', payload);

                const contestId = payload?.contestId;
                const lobbyUsersObj = payload?.roomState?.lobbyUsers || [];
                setJoinedUsersList(lobbyUsersObj);
                // if (contestId && rapFireGameList && contestId === rapFireGameList.contestId) {
                //     setJoinedUsersList(prev => {
                //         // Convert lobbyUsers object to array if needed
                //         const lobbyUsersArr = Array.isArray(lobbyUsersObj)
                //             ? lobbyUsersObj
                //             : Object.values(lobbyUsersObj);
                //         // Merge, avoiding duplicates by userId
                //         const allUsers = [...prev, ...lobbyUsersArr];
                //         const uniqueUsers = [];
                //         const seen = new Set();
                //         for (const user of allUsers) {
                //             const id = user.userId || user.id;
                //             if (!seen.has(id)) {
                //                 seen.add(id);
                //                 uniqueUsers.push(user);
                //             }
                //         }
                //         return uniqueUsers;
                //     });
                // }
                setIsStartEnabled(true);
            },
            'Game_Abandon': async (payload) => {
                // {
                //     "event": "Game_Abandon",
                //     "contestId": "69257d71f31048b57e0c499f",
                //     "roomId": "69257e13f31048b57e0c49a8",
                //     "reason": "Insufficient players",
                //     "timestamp": 1764064818269,
                //     "message": "Game abandoned due to insufficient players (1/2)",
                //     "filledSpots": 1,
                //     "minSpots": 2
                // }

                logger.log('MQTT game_abandon:', payload);
                setTimerDisplay("00 : 00");
                setRapFireNoGameList('Sorry, Game abandoned due to insufficient players.');
                setJoinedUsersList([]);
                setRapFireGameList(null);
                setIsStartEnabled(false);
            },
            'countdown': async (payload) => {
                logger.log('MQTT countdown:', payload);
                if (payload?.count === 3) {
                    navigate(ROUTE_ENUM.RAP_FIRE_GAME.routePath, { replace: true, state: { contestId: payload?.contestId } });
                }
            },
            'next_question': async (payload) => {
                logger.log('MQTT next_question (waiting stash):', payload);
                stashRapFireNextQuestion(payload);
            },
            error: (err) => {
                console.error('MQTT error:', err);
            },
            complete: () => {
                logger.log('MQTT subscription complete');
            },
        });
    }

    const disconnectMQTT = () => {
        mqttService.disconnect();
    }

    const handleStartGame = () => {
        logger.log('Start game clicked');
        gameListRapFire();
    };

    return (
        <>
            <ParentContainor
                route={ROUTE_ENUM.RAP_FIRE_GAME}
                parentContainorStyle={{ justifyContent: 'center' }}
                isShowHeader={true}
                isBreadcrumbVisible={true}
                breadCrumbShowBack={true}
                breadCrumbOnBack={() => navigate(ROUTE_ENUM.SELECT_RAP_FIRE_GAME.routePath)}
                breadCrumbItems={[]}
            >
                <div style={{
                    display: 'flex',
                    flex: 1,
                    height: '85%',
                    width: '100%',
                    flexDirection: 'column',
                    gap: 0,
                    padding: 0,
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: -10,
                }}>
                    <div style={{
                        display: 'flex',
                        flex: 1,
                        height: '100%',
                        width: '100%',
                        flexDirection: 'row',
                        gap: 40,
                        padding: 50,
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        marginTop: 0,
                    }}>

                        {<Card
                            elevation={5}
                            radius={20}
                            animation={true}
                            style={{
                                display: 'flex',
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 20,
                                paddingBottom: 0,
                                height: '100%',
                                width: '25%',
                                justifyContent: 'start',
                                alignItems: 'center',
                                flexDirection: 'column',
                            }}>

                            {joinedUsersList?.length > 0 ? <div style={{
                                display: 'flex',
                                flex: 1,
                                height: '100%',
                                width: '100%',
                                flexDirection: 'column',
                                gap: 0,
                                justifyContent: 'start',
                                alignItems: 'start',
                            }}>

                                <GradientText
                                    text={`${TEXT_LABELS.RAP_HOUSIE_ROOM_GAME_CODE_SHARE_TOTAL_JOINED}${joinedUsersList?.length || 0}`}
                                    fontWeight={700}
                                    fontSize={24}
                                    textColor={'#FFFFFFE5'}
                                    style={{
                                        marginTop: 0
                                    }}
                                />

                                <div style={{
                                    flex: 1,
                                    height: '100%',
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'start',
                                    overflowY: 'auto',
                                    marginTop: 10,
                                    overflowY: 'auto',
                                    scrollbarWidth: 'none', /* Firefox */
                                    msOverflowStyle: 'none', /* IE and Edge */
                                }}>
                                    {

                                        joinedUsersList?.map((player, index) => {
                                            const userId = player?.userId;
                                            const avatar = player?.profilePic || IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER;
                                            const username = player?.userName || '';
                                            const joinTime = player?.joinTime || '';
                                            return (
                                                <div key={index}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'rotate(-0deg) scale(1.01)'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'rotate(-0deg) scale(1)'}
                                                    style={{
                                                        flex: 0,
                                                        flexDirection: 'row',
                                                        height: 'auto',
                                                        width: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        transform: 'rotate(-0deg)',
                                                        transition: 'transform 0.3s ease',
                                                        marginBottom: 10,
                                                    }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        flex: 1,
                                                        height: '100%',
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        gap: 20,
                                                        justifyContent: 'start',
                                                        alignItems: 'center',
                                                    }}>
                                                        <GradientText
                                                            text={index + 1}
                                                            fontWeight={500}
                                                            fontSize={16}
                                                            textColor={'#FFFFFF'}
                                                            style={{
                                                                marginTop: 0
                                                            }}
                                                            color="#5FE72EB2"
                                                        />

                                                        <ImageView
                                                            src={avatar}
                                                            alt={username}
                                                            width="40px"
                                                            height="40px"
                                                            borderRadius="50%"
                                                            objectFit="contain"
                                                            border='1px solid #FFFFFF33'
                                                        />

                                                        <GradientText
                                                            text={username}
                                                            fontWeight={600}
                                                            fontSize={18}
                                                            textColor={'#FFFFFFB2'}
                                                            style={{
                                                                marginTop: 0
                                                            }}
                                                        />
                                                    </div>

                                                    <GradientText
                                                        text="Joined"
                                                        fontWeight={600}
                                                        fontSize={14}
                                                        textColor={'#5FE72EB2'}
                                                        style={{
                                                            marginTop: 0
                                                        }}
                                                    />
                                                </div>
                                            )
                                        })
                                    }

                                </div>

                            </div> : (
                                <span style={{
                                    color: '#fff',
                                    opacity: 0.5,
                                    fontSize: 16,
                                    marginTop: 16,
                                    fontFamily: FONTS.MONTSERRAT_REGULAR,
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    alignContent: 'center'
                                }}>No users joined yet.</span>
                            )}

                        </Card>}

                        <div style={{
                            display: 'flex',
                            flex: 1,
                            height: '100%',
                            width: '100%',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            alignContent: 'center',
                        }}>
                            {
                                <Card
                                    elevation={5}
                                    radius={20}
                                    animation={false}
                                    style={{
                                        display: 'flex',
                                        padding: '20px',
                                        height: '100%',
                                        width: '70%',
                                        justifyContent: 'start',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                    }}>

                                    <div style={{
                                        display: 'flex',
                                        flex: 1,
                                        height: '100%',
                                        width: '100%',
                                        flexDirection: 'column',
                                        gap: 30,
                                        padding: 10,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}>

                                        <div style={{
                                            display: 'flex',
                                            width: '40%',
                                            flexDirection: 'column',
                                            gap: 0,
                                            padding: 10,
                                            justifyContent: 'start',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            flex: 0,
                                        }}>
                                            <GradientText
                                                text={`${TEXT_LABELS.RAP_HOUSIE_GAME_START_TIMER_WELCOME_TITLE}`}
                                                fontWeight={600}
                                                fontSize={42}
                                                fontFamily={FONTS.MONTSERRAT_BOLD}
                                                style={{
                                                    marginTop: 20
                                                }}
                                            />
                                            <GradientText
                                                text={`${TEXT_LABELS.RAP_FIRE_GAME_START_TIMER_WELCOME_TITLE_RAPFIRE}`}
                                                fontWeight={700}
                                                fontFamily={FONTS.MONTSERRAT_BOLD}
                                                fontSize={72}
                                                style={{
                                                    marginTop: 10
                                                }}
                                            />
                                        </div>

                                        {isGameLoading &&
                                            <div style={{
                                                display: 'flex',
                                                flex: 1,
                                                width: '100%',
                                                height: '100%',
                                                flexDirection: 'column',
                                                gap: 0,
                                                padding: 0,
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                textAlign: 'center',
                                            }}>
                                                <GradientText
                                                    text={`${TEXT_LABELS.RAP_HOUSIE_GAME_START_TIMER_WELCOME_SUBTITLE}`}
                                                    fontWeight={600}
                                                    fontSize={36}
                                                    style={{
                                                        marginTop: 0
                                                    }}
                                                />

                                                <GradientText
                                                    text={timerDisplay}
                                                    fontWeight={700}
                                                    fontSize={142}
                                                    gradientColor1={COLORS_CONSTANTS.RAP_HOUSIE_ROOM_CODE_TEXT_GRADIENT_1_COLOR_1}
                                                    gradientColor2={COLORS_CONSTANTS.RAP_HOUSIE_ROOM_CODE_TEXT_GRADIENT_1_COLOR_2}
                                                    style={{
                                                        marginTop: 0,
                                                        fontStyle: 'italic',
                                                        width: '100%',
                                                        textAlign: 'center',
                                                    }}
                                                />
                                            </div>}

                                        {isRetryModeOn && <div style={{
                                            flex: 1,
                                            display: 'flex',
                                            width: 'auto',
                                            height: '100%',
                                            justifyContent: 'start',
                                            alignItems: 'center',
                                            alignContent: 'center',
                                        }}>
                                            <div style={{
                                                flex: 1,
                                                display: 'flex',
                                                width: 'auto',
                                                height: '100%',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                alignContent: 'center',
                                            }}>

                                                <QRCode
                                                    value="RAP_HOUSIE_EVENT_QR"
                                                    width="15vw"
                                                    height="30vh"
                                                    backgroundColor="#F3F3F3"
                                                    borderColor="#ffffff"
                                                    borderRadius="40px"
                                                />

                                                <GradientText
                                                    text={`${rapFireNoGameList}`}
                                                    fontWeight={600}
                                                    fontSize={18}
                                                    style={{
                                                        marginTop: 30,
                                                        textAlign: 'center',
                                                    }}
                                                />

                                                <Button
                                                    text={'Try Again'}
                                                    onClick={handleStartGame}
                                                    backgroundColor={COLORS_CONSTANTS.ACTION_BUTTON_BACKGROUND_1}
                                                    color={COLORS_CONSTANTS.ACTION_BUTTON_TEXT_1}
                                                    height={'60px'}
                                                    fontSize={28}
                                                    fontWeight={700}
                                                    borderRadius={'10px'}
                                                    disabled={false}
                                                    style={{ marginTop: 20, marginBottom: 40, paddingLeft: 100, paddingRight: 100 }}
                                                />
                                            </div>
                                        </div>}
                                    </div>
                                </Card>}
                        </div>
                    </div>
                </div>
            </ParentContainor>
        </>
    );
};

export default RapFireWaiting;